export default __webpack_public_path__ + "static/media/bookings-list.24158225.png";